import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }

import { computed, provide, ref } from 'vue';
import { useRoute } from 'vue-router';
import BrandedLayout from '@/layouts/BrandedLayout.vue';
import ConstrainedLayout from '@/layouts/ConstrainedLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import Alert from '@/components/Modal/Alert.vue';
import Prompt from '@/components/Modal/Prompt.vue';
import { AlertModal, PromptModal } from '@/typings/modal';
import TheNotificationContainer from '@/components/Notifications/TheNotificationContainer.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const isDataManagement = computed(() => route.path.includes('/data/'));

const showNav = computed(
  () =>
    ![
      'Login',
      'LoginHome',
      'ForgottenPassword',
      'Register',
      'TwitterLogin',
      'TwitterSignup',
      'ResetPassword',
      'TwitterWarning',
    ].includes(route.name ? route.name.toString() : '')
);

const alertModal = ref<AlertModal>();
provide('alertModal', alertModal);
const promptModal = ref<PromptModal>();
provide('promptModal', promptModal);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TheNotificationContainer),
    (_unref(isDataManagement))
      ? (_openBlock(), _createBlock(ConstrainedLayout, { key: 0 }))
      : (_unref(showNav))
        ? (_openBlock(), _createBlock(DefaultLayout, { key: 1 }))
        : (_openBlock(), _createBlock(BrandedLayout, { key: 2 })),
    _createVNode(Alert, {
      ref: (_value, _refs) => {
        _refs['alertModal'] = _value
        alertModal.value = _value
      }
    }, null, 512),
    _createVNode(Prompt, {
      ref: (_value, _refs) => {
        _refs['promptModal'] = _value
        promptModal.value = _value
      }
    }, null, 512)
  ]))
}
}

})